import { createAction, props } from '@ngrx/store';
import { Attachment, Client, ClinicalNote, ClinicalNoteEmail, CommunicationRecord, DocumentInstance, GraphAggregate, GraphAggregateChange, GraphAggregateChangeOperation, GraphChangeContext, PartialEntity, Patient, PatientRecordTask, Visit } from 'src/app/types/aggregate-graph.types';

export enum PatientGraphActionTypes {
	SubscribePatientRequested = '[Patient Effect] Subscribe Patient Requested',
	UnsubscribePatientRequested = '[Patient Effect] Unsubscribe Patient Requested',
	PatientGraphGenerated = '[Aggregate Graph Hub] Patient Graph Generated',
	PatientGraphChanged = '[Aggregate Graph Hub] Patient Graph Changed',
	PatientGraphValueChanged = '[Aggregate Graph Hub] Patient Graph Value Changed',
	PatientGraphLoaded = '[Patient Effect] Patient Graph Loaded',
	PatientUpdated = '[Patient Effect] Patient Updated',
	CommunicationRecordAdded = '[Patient Effect] Communication Record Added',
	CommunicationRecordUpdated = '[Patient Effect] Communication Record Updated',
	CommunicationRecordRemoved = '[Patient Effect] Communication Record Removed',
	ClinicalNoteEmailAdded = '[Patient Effect] Clinical Note Email Added',
	ClientUpdated = '[Patient Effect] Client Updated',
	VisitUpdated = '[Patient Effect] Visit Updated',
	VisitAdded = '[Patient Effect] Visit Added',
	AttachmentAdded = '[Patient Effect] Attachment Added',
	AttachmentUpdated = '[Patient Effect] Attachment Updated',
	AttachmentRemoved = '[Patient Effect] Attachment Removed',
	ClinicalNoteAdded = '[Patient Effect] Clinical Note Added',
	ClinicalNoteUpdated = '[Patient Effect] Clinical Note Updated',
	TaskAdded = '[Patient Effect] Task Added',
	TaskUpdated = '[Patient Effect] Task Updated',
	DocumentInstanceAdded = '[Patient Effect] Document Instance Added',
	DocumentInstanceUpdated = '[Patient Effect] Document Instance Updated',
	PatientGraphSystemRestarted = '[Aggregate Graph Hub] Patient Graph System Restarted',
	ReloadPatientRequested = '[Patient Effect] Reload Patient Requested'
}

export const subscribePatientRequested = createAction(
	PatientGraphActionTypes.SubscribePatientRequested,
	props<{ patientChanged: boolean, patientId: string, taskId: string, serviceId: string }>()
)

export const unsubscribePatientRequested = createAction(
	PatientGraphActionTypes.UnsubscribePatientRequested
)

export const patientGraphGenerated = createAction(
	PatientGraphActionTypes.PatientGraphGenerated,
	props<{ patientId: string, aggregates: GraphAggregate[] }>()
)

export const patientGraphChanged = createAction(
	PatientGraphActionTypes.PatientGraphChanged,
	props<{ patientId: string, changes: GraphAggregateChange[], context: GraphChangeContext }>()
)

export const patientGraphValueChanged = createAction(
	PatientGraphActionTypes.PatientGraphValueChanged,
	props<{ patientId: string, operation: GraphAggregateChangeOperation, valueTypeName: string, value: any, context: GraphChangeContext }>()
)

export const patientGraphLoaded = createAction(
	PatientGraphActionTypes.PatientGraphLoaded,
	props<{ patient: Patient, clients: Client[], attachments: Attachment[], visits: Visit[], clinicalNotes: ClinicalNote[], tasks: PatientRecordTask[], documentInstances: DocumentInstance[] }>()
)

export const patientUpdated = createAction(
	PatientGraphActionTypes.PatientUpdated,
	props<{ partialPatient: PartialEntity<Patient> }>()
)

export const communicationRecordAdded = createAction(
	PatientGraphActionTypes.CommunicationRecordAdded,
	props<{ record: CommunicationRecord }>()
)

export const communicationRecordUpdated = createAction(
	PatientGraphActionTypes.CommunicationRecordUpdated,
	props<{ record: CommunicationRecord }>()
)

export const communicationRecordRemoved = createAction(
	PatientGraphActionTypes.CommunicationRecordRemoved,
	props<{ recordId: number }>()
)

export const clinicalNoteEmailAdded = createAction(
	PatientGraphActionTypes.ClinicalNoteEmailAdded,
	props<{ email: ClinicalNoteEmail }>()
)

export const clientUpdated = createAction(
	PatientGraphActionTypes.ClientUpdated,
	props<{ partialClient: PartialEntity<Client> }>()
)

export const visitUpdated = createAction(
	PatientGraphActionTypes.VisitUpdated,
	props<{ partialVisit: PartialEntity<Visit> }>()
)

export const visitAdded = createAction(
	PatientGraphActionTypes.VisitAdded,
	props<{ visit: Visit }>()
)

export const attachmentAdded = createAction(
	PatientGraphActionTypes.AttachmentAdded,
	props<{ attachment: Attachment }>()
)

export const attachmentUpdated = createAction(
	PatientGraphActionTypes.AttachmentUpdated,
	props<{ partialAttachment: PartialEntity<Attachment> }>()
)

export const attachmentRemoved = createAction(
	PatientGraphActionTypes.AttachmentRemoved,
	props<{ id: string }>()
)

export const clinicalNoteAdded = createAction(
	PatientGraphActionTypes.ClinicalNoteAdded,
	props<{ clinicalNote: ClinicalNote }>()
)

export const clinicalNoteUpdated = createAction(
	PatientGraphActionTypes.ClinicalNoteUpdated,
	props<{ partialClinicalNote: PartialEntity<ClinicalNote> }>()
)

export const taskAdded = createAction(
	PatientGraphActionTypes.TaskAdded,
	props<{ task: PatientRecordTask }>()
)

export const taskUpdated = createAction(
	PatientGraphActionTypes.TaskUpdated,
	props<{ partialTask: PartialEntity<PatientRecordTask> }>()
)

export const documentInstanceAdded = createAction(
	PatientGraphActionTypes.DocumentInstanceAdded,
	props<{ documentInstance: DocumentInstance }>()
)

export const documentInstanceUpdated = createAction(
	PatientGraphActionTypes.DocumentInstanceUpdated,
	props<{ partialDocumentInstance: PartialEntity<DocumentInstance> }>()
)

export const patientGraphSystemRestarted = createAction(
	PatientGraphActionTypes.PatientGraphSystemRestarted
)

export const reloadPatientRequested = createAction(
	PatientGraphActionTypes.ReloadPatientRequested
)